import { showSuccessNotification } from "molecules/notifications/notificationEvents";
import { useEffect } from "react";
import { isEditableTarget } from "src/common/utils/isEditableTarget.js";
import { useLanguagePreference } from "src/common/utils/hooks/useLanguagePreference.js";

const languages = ["sv", "en"] as const;

export const useLanguageToggle = () => {
	const { language, changeLanguage } = useLanguagePreference();

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key !== "l" && e.key !== "L") return;
			if (e.metaKey || e.ctrlKey || e.altKey) return;
			if (isEditableTarget(e.target)) return;

			const currentIndex = languages.indexOf(
				language as (typeof languages)[number],
			);
			const nextLanguage =
				languages[(currentIndex + 1) % languages.length] ?? languages[0];

			changeLanguage(nextLanguage);
			showSuccessNotification({
				message: nextLanguage === "sv" ? "Svenska" : "English",
				autoClose: 1000,
			});
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [language, changeLanguage]);
};
